import React, { useEffect, useState } from 'react';
import { Box, TextField, Button, Typography, Paper,Grid,IconButton } from '@mui/material';
import axios from 'axios';
import { useNotification } from "../../components/NotificationContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
const ShippingFee = () => {
    const showNotification = useNotification();
    const navigate = useNavigate();
  const [formData, setFormData] = useState({
    shipping_fee: '',
    min_free_shipping: '',
    min_cod_payment: ''
  });

  const [loading, setLoading] = useState(false);

  // Verileri çek
  useEffect(() => {
    const fetchData = async () => {
      try {

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/product/getShippingInfo`, {

        });

        setFormData({
          shipping_fee: response.data.shipping_fee || '',
          min_free_shipping: response.data.order_min_pay || '',
          min_cod_payment: response.data.cash_payment_min || ''
        });
      } catch (error) {
        showNotification("Veriler getirilemedi!", "error");
      }
    };

    fetchData();
  }, []);

  // Input değişikliği
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Güncelleme isteği
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      await axios.put(`${process.env.REACT_APP_API_URL}/orders/ShippingFee`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showNotification("Kargo Ayarları Başarıyla Güncellendi!", "success");
    } catch (error) {
      console.error("Güncelleme hatası:", error);
      showNotification("Güncelleme Sırasında Bir Hata Oluştu!", "error");
    } finally {
      setLoading(false);
    }
  };
  const handleBackClick = () => {
    navigate(-1);
  };


  return (
    <Grid container justifyContent="center" alignItems="center">
    <Grid size={{ xs: 12, sm: 10,md:10 }}>
    <Paper
      elevation={5}
      style={{
        padding: "30px",
        borderRadius: "15px",
        backgroundColor: "#ffffff",
      }}
    >
      <IconButton onClick={handleBackClick} style={{ marginBottom: "10px" }}>
        <ArrowBackIcon />
      </IconButton>

      <Typography
        variant="h4"
        align="center"
        gutterBottom
        style={{ fontWeight: 600, color: "#3f51b5" }}
      >
        Ürün İndirimi Güncelle
      </Typography>

      <TextField
        label="Kargo Ücreti (₺)"
        name="shipping_fee"
        value={formData.shipping_fee}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />

      <TextField
        label="Ücretsiz Kargo için Minimum Tutar (₺)"
        name="min_free_shipping"
        value={formData.min_free_shipping}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />

      <TextField
        label="Kapıda Ödeme için Minimum Tutar (₺)"
        name="min_cod_payment"
        value={formData.min_cod_payment}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />

      <Box mt={3} textAlign="right">
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? "Kaydediliyor..." : "Güncelle"}
        </Button>
      </Box>
    </Paper>
  </Grid>
</Grid>
  );
};

export default ShippingFee;
